export const handleDonorIdChange = (
e,
setDonorId,
setEmiratesId,
setEmiratesYear,
setErrorMessage,
setEmiratesIdError,
translationMap) =>
{
  const value = e.target.value.replace(/\D/g, "");
  setDonorId(value);
  setEmiratesIdError("");

  if (value.length > 0) {
    setEmiratesId("");
    setEmiratesYear("");
  }
  if (value === "") {
    setErrorMessage(translationMap?.pleaseEnterDonorId || "Please enter Donor Id");
  } else {
    setErrorMessage("");
  }

};

export const handleEmiratesIdChange = (
e,
setEmiratesId,
setDonorId,
setDonorYear,
setErrorMessage,
setMrnError,
translationMap) =>
{
  let value = e.target.value.replace(/\D/g, "");
  if (value.length > 15) {
    value = value.slice(0, 15);
  }
  setEmiratesId(value);
  setMrnError("");
  if (value) {
    setDonorId("");
    setDonorYear("");
  }
  if (value === "") {
    setErrorMessage("");
  } else if (value.length !== 15) {
    setErrorMessage(translationMap?.emiratesIdShouldBeFifteen || "Emirates Id Should be 15");
  } else {
    const formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(
      7,
      14
    )}-${value.slice(14)}`;
    setEmiratesId(formatted);
    setErrorMessage("");
  }
};